module.exports = __webpack_public_path__ + "boat.683c3323.gif";